import { services } from "../../../../constants/services";
import { getAll } from "../../../../utils/api";

export const GetReactionsService = async () => {
  const response: any = await getAll<any[]>(`${services.reactions}`);
  return response?.data;
};